
import * as types from './const'


export const getServiceTicketAction = (data) => async dispatch => {
    if (data) {
        dispatch({
            type: types.GET_SERVICE_TICKET,
            data
        })
    }else{
        dispatch({
            type: types.GET_SERVICE_TICKET_ERR,
            
        })
    }
}

